var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { Dialog as MuiDialog } from '@material-ui/core';
import { makeStyles } from "../../styles/index";
var useStyles = makeStyles(function (theme) { return ({
    paper: {
        borderRadius: 0,
        boxShadow: theme.shadows[2],
    },
    notFullScreen: {
        minWidth: 400,
        minHeight: 278,
        maxWidth: 928,
        maxHeight: 546,
    },
    backdropRoot: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },
}); }, { name: 'SnDialog' });
/**
 * ダイアログコンポーネント。
 */
export var Dialog = React.forwardRef(function (props, ref) {
    var _a;
    // 型定義的には`others`に要素は1つもないが、UiKitを利用するプロジェクトで付与されるカスタムデータ属性を引き渡すために`others`を使用している。
    var open = props.open, fullScreen = props.fullScreen, children = props.children, className = props.className, style = props.style, classesProp = props.classes, others = __rest(props, ["open", "fullScreen", "children", "className", "style", "classes"]);
    var classes = useStyles({ classes: classesProp });
    var paperClass = classNames((_a = {},
        _a[classes.paper] = true,
        _a[classes.notFullScreen] = !fullScreen,
        _a), className);
    return (React.createElement(MuiDialog, __assign({ ref: ref, open: open, classes: { paper: paperClass }, PaperProps: { style: style }, BackdropProps: { classes: { root: classes.backdropRoot } }, fullScreen: fullScreen, disableEnforceFocus: true, transitionDuration: { enter: 0 } }, others), children));
});
